<!--
 * @Author: Merlin
 * @Date: 2024-06-06 10:33:46
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-24 17:22:41
 * @Description: 
-->
<template>
    <!-- <CasinoHistoryHeaderCell
        :text="t.Game.toUpperCase()"
        class="md:flex-[0.6]"
    />
    <CasinoHistoryHeaderCell :text="t.Time.toUpperCase()" />
    -->
    <!--
        💎💎💎
        重要说明：以上2列在 Mini 版中被废弃了
        暂时注释，将来删除 2024.06.21 16:50:27 星期五 
    -->
    <CasinoHistoryHeaderCell
        :text="t.USER.toUpperCase()"
        class="flex-[0.3]"
    />
    <CasinoHistoryHeaderCell
        class="flex-[0.8]"
        :text="t.BetAmount.toUpperCase()"
    />
    <CasinoHistoryHeaderCell 
        class="flex-[0_1_78px]"
        :text="t.Multiplier.toUpperCase()"
    />
    <CasinoHistoryHeaderCell
        class="flex-1 !pr-0"
        :text="t.Payout.toUpperCase()"
    />
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
});

</script>
